var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlanet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9198 10.3106V13.8372H26.1623V19.1213H27.9198V20.8788H29.6889V22.6478H24.4048V24.4053H22.6357V26.1628H27.9198V29.6894H26.1623V33.2159H27.9198V34.9734H31.4464V33.2159H33.2154V31.4469H34.9729V27.9319H36.7304V24.4053H38.4995V15.5947H36.7304V12.0681H34.9729V8.55313H33.2154V10.3106H27.9198Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2158 6.78407H31.4468V8.55313H33.2158V6.78407Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4465 5.02657H27.9199V6.78407H31.4465V5.02657Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9203 34.9734H24.4053V36.7425H27.9203V34.9734Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9203 3.25751H24.4053V5.02657H27.9203V3.25751Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8795 34.9734H19.122V33.2159H13.8263V34.9734H12.0688V36.7425H15.5954V38.5H24.406V36.7425H20.8795V34.9734Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4054 1.5H15.5947V3.2575H24.4054V1.5Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8267 20.8788H15.5957V22.6478H17.3532V17.3522H13.8267V20.8788Z",
    fill: "#FBC04E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0676 33.2159H8.54102V34.9734H12.0676V33.2159Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.54119 31.4469H6.78369V33.2159H8.54119V31.4469Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.02656 27.9319V31.4469H6.78406V29.6894H8.54156V27.9319H10.3106V22.6478H8.54156V20.8788H6.78406V19.1213H5.02656V17.3522H6.78406V15.5947H12.0681V13.8372H13.8256V12.0681H15.5947V13.8372H17.3522V12.0681H19.1213V8.55313H17.3522V6.78407H13.8256V5.02657H15.5947V3.25751H12.0681V5.02657H8.54156V6.78407H6.78406V8.55313H5.02656V12.0681H3.2575V15.5947H1.5V24.4053H3.2575V27.9319H5.02656Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanet);
export default __webpack_public_path__ + "static/media/planet.a7a2e640a0e8023c91e93b20cc19192b.svg";
export { ForwardRef as ReactComponent };